import React from 'react';
import { useSelector } from 'react-redux';
import { getClassLabelKey } from '../../../../../../utils/utils';
import classes from './ClassNameCell.module.css';

const ClassNameCell = ({ row }) => {

  const { texts } = useSelector(state => state.translate);
  const classLetter = texts[getClassLabelKey(row?.class)];
  const formattedName = `${texts.class} ${classLetter}'${row.ordinal}`;

  return (
    <div className={classes.classNameCell}>
      {formattedName}
    </div>
  );
};

export default ClassNameCell;
